import { useCustomerTicketsPage } from "modules/customerTickets/pages/CustomerTickets/context";
import React, { useState } from "react";
import Header from "./components/Header";
import MessageInput from "./components/MessageInput";
import Messages from "./components/Messages";
import TicketDetails from "./components/TicketDetails";
import Empty from "./empty";
import { StyledContainer, StyledTicketChatContainer } from "./styled";

const TicketContent = () => {
  const { selectedTicket, ticketStatus } = useCustomerTicketsPage();
  const [inputHeight, setInputHeight] = useState(104); // Default value from min-height of input

  if (!selectedTicket) {
    return <Empty />;
  }

  return (
    <StyledContainer>
      <StyledTicketChatContainer>
        <Header
          ticketTitle={selectedTicket.title}
          ticketCategory={selectedTicket.category?.key}
          ticketSubcategory={selectedTicket.subCategory?.key ?? ""}
          status={ticketStatus}
        />
        <Messages inputHeight={inputHeight} />
        <MessageInput setContainerHeight={setInputHeight} />
      </StyledTicketChatContainer>
      <TicketDetails />
    </StyledContainer>
  );
};

export default TicketContent;
